// extracted by mini-css-extract-plugin
module.exports = {"itemTitle":"DeliveryDetails_itemTitle__DrO-g","itemText":"DeliveryDetails_itemText__J3YZZ"};